import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SmartphoneIcon, TvIcon, MonitorIcon, WrenchIcon, SettingsIcon, CheckIcon, GiftIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="bg-zinc-950 py-16 sm:py-24" id="precio" data-id="element-242">
      <div className="max-w-4xl mx-auto px-4" data-id="element-243">
        {/* Product intro */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-244">
          <span className="inline-block bg-emerald-500/10 text-emerald-400 text-sm font-bold px-4 py-2 rounded-full mb-6" data-id="element-245">
            PRESENTAMOS
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-246">
            Guía Definitiva: Instala Magis TV en{' '}
            <span className="text-emerald-400" data-id="element-247">Celular y Smart TV</span>
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-248">
            Paso a Paso 2025 — La única guía visual, actualizada y a prueba de
            errores que te lleva desde cero hasta tener Magis TV funcionando en
            menos de 15 minutos.
          </p>
        </motion.div>

        {/* Modules */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-zinc-900 to-zinc-900/50 border border-zinc-800 rounded-2xl p-6 sm:p-8 mb-8" data-id="element-249">
          <h3 className="text-white font-bold text-xl mb-6 flex items-center gap-2" data-id="element-250">
            <BookOpenIcon className="w-6 h-6 text-emerald-400" data-id="element-251" />
            ¿Qué incluye la guía?
          </h3>

          <div className="space-y-4" data-id="element-252">
            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-253">
              <div className="w-10 h-10 bg-emerald-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-254">
                <span className="text-emerald-400 font-bold" data-id="element-255">1</span>
              </div>
              <div data-id="element-256">
                <h4 className="text-white font-semibold" data-id="element-257">
                  ¿Qué es Magis TV y cómo funciona?
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-258">
                  Sin tecnicismos, explicado simple
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-259">
              <div className="w-10 h-10 bg-emerald-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-260">
                <SmartphoneIcon className="w-5 h-5 text-emerald-400" data-id="element-261" />
              </div>
              <div data-id="element-262">
                <h4 className="text-white font-semibold" data-id="element-263">
                  Instalación en celular Android
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-264">
                  Capturas paso a paso para cualquier modelo
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-265">
              <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-266">
                <TvIcon className="w-5 h-5 text-cyan-400" data-id="element-267" />
              </div>
              <div data-id="element-268">
                <h4 className="text-white font-semibold" data-id="element-269">
                  Instalación en Smart TV con Android TV
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-270">
                  Método Downloader incluido
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-271">
              <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-272">
                <MonitorIcon className="w-5 h-5 text-amber-400" data-id="element-273" />
              </div>
              <div data-id="element-274">
                <h4 className="text-white font-semibold" data-id="element-275">
                  Fire TV Stick y Chromecast con Google TV
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-276">
                  Instrucciones específicas para cada dispositivo
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-277">
              <div className="w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-278">
                <WrenchIcon className="w-5 h-5 text-red-400" data-id="element-279" />
              </div>
              <div data-id="element-280">
                <h4 className="text-white font-semibold" data-id="element-281">
                  Los 5 errores más comunes
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-282">
                  Y cómo resolverlos al instante
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-283">
              <div className="w-10 h-10 bg-purple-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-284">
                <SettingsIcon className="w-5 h-5 text-purple-400" data-id="element-285" />
              </div>
              <div data-id="element-286">
                <h4 className="text-white font-semibold" data-id="element-287">
                  Configuración para máxima calidad
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-288">
                  Ajustes recomendados para mejor experiencia
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bonus */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-2xl p-6 sm:p-8 mb-10" data-id="element-289">
          <div className="flex items-center gap-3 mb-4" data-id="element-290">
            <GiftIcon className="w-6 h-6 text-amber-400" data-id="element-291" />
            <span className="text-amber-400 font-bold text-lg" data-id="element-292">
              BONUS INCLUIDO
            </span>
          </div>
          <h4 className="text-white font-bold text-xl mb-2" data-id="element-293">
            Checklist de instalación imprimible
          </h4>
          <p className="text-zinc-400" data-id="element-294">
            Para no perderse ni un paso — marca cada item mientras avanzas
          </p>
        </motion.div>

        {/* What you get summary */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 sm:p-8" data-id="element-295">
          <h3 className="text-white font-bold text-xl mb-6 text-center" data-id="element-296">
            Lo que obtienes hoy:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-297">
            <div className="flex items-center gap-3" data-id="element-298">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-299" />
              <span className="text-zinc-300" data-id="element-300">Guía completa en PDF</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-301">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-302" />
              <span className="text-zinc-300" data-id="element-303">Capturas de pantalla reales</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-304">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-305" />
              <span className="text-zinc-300" data-id="element-306">6 módulos paso a paso</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-307">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-308" />
              <span className="text-zinc-300" data-id="element-309">Solución de errores comunes</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-310">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-311" />
              <span className="text-zinc-300" data-id="element-312">
                Checklist imprimible (bonus)
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-313">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-314" />
              <span className="text-zinc-300" data-id="element-315">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}